module.exports = __webpack_public_path__ + "img/logo-light.a5421a34.png";